(function () {
  // MNR-717: Inline Sales Agent — Einstiegspunkt in die Chatbubble.
  if (window.inlineSalesAgentInit) return;
  window.inlineSalesAgentInit = true;

  function getSections() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-inline-sales-agent]'));
  }

  // Der UC-Service-Name kommt per data-Attribut aus der Section (pro Markt in
  // shop.metafields.mnr.sales_agent_uc_service_name gepflegt). Fallback: "sales agent".
  function getServiceName(section) {
    const raw = (section.getAttribute('data-uc-service') || '').trim();
    return (raw || 'sales agent').toLowerCase();
  }

  async function getServices() {
    if (typeof UC_UI === 'undefined' || !UC_UI.getServicesBaseInfo) return [];
    try {
      return (await UC_UI.getServicesBaseInfo()) || [];
    } catch (e) {
      console.warn('Inline Sales Agent: UC_UI.getServicesBaseInfo() failed:', e);
      return [];
    }
  }

  function findService(services, serviceName) {
    for (const s of services) {
      if ((s.name || '').toLowerCase().includes(serviceName)) return s;
    }
    return null;
  }

  function hasConsent(service) {
    return service && service.consent && service.consent.status === true;
  }

  function reveal(section) {
    // Consent-Status cachen, damit handoff() ihn synchron prüfen kann (Stale-Consent-Race).
    section.dataset.consentGranted = '1';
    if (!section.hasAttribute('hidden')) return;
    section.removeAttribute('hidden');
    bindForm(section);
  }

  function hide(section) {
    delete section.dataset.consentGranted;
    // Fokus nicht auf einem gleich versteckten Element hängen lassen (Consent-Widerruf
    // während der Input fokussiert ist) — vorher aus der Section herausblurren.
    if (section.contains(document.activeElement) && document.activeElement.blur) {
      document.activeElement.blur();
    }
    section.setAttribute('hidden', '');
  }

  function bindForm(section) {
    const form = section.querySelector('[data-inline-sales-agent-form]');
    if (!form || form.dataset.bound === '1') return;
    form.dataset.bound = '1';

    // Ein Submit-Handler deckt Enter UND Submit-Button ab (beides löst submit aus).
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      const input = form.querySelector('[data-inline-sales-agent-input]');
      const value = input ? input.value.trim() : '';
      if (!value) return;

      const handled = handoff(value, section);

      // Input erst nach erfolgreicher Übergabe zurücksetzen.
      if (handled && input) input.value = '';
    });
  }

  function handoff(value, section) {
    // Consent erneut prüfen: eine noch sichtbare Section darf nicht übergeben, wenn der
    // Consent zwischenzeitlich (während eines laufenden applyConsent-Refreshs) widerrufen wurde.
    if (section.dataset.consentGranted !== '1') return false;

    const widget = window.magnamateWidget;

    if (!widget || typeof widget.openSalesAgent !== 'function') {
      console.error('Inline Sales Agent: window.magnamateWidget.openSalesAgent() ist nicht verfügbar.');
      return false;
    }

    try {
      widget.openSalesAgent({ message: value, product: productContext(section) });
      return true;
    } catch (e) {
      console.error('Inline Sales Agent: magnamateWidget.openSalesAgent() failed:', e);
      return false;
    }
  }

  function productContext(section) {
    const handle = section.getAttribute('data-product-handle');
    if (!handle) return null;
    const product = { handle: handle, title: section.getAttribute('data-product-title') || '' };
    const imageUrl = section.getAttribute('data-product-image');
    // imageUrl nur mitgeben, wenn vorhanden (Produkt ohne Bild → weglassen).
    if (imageUrl) product.imageUrl = imageUrl;
    return product;
  }

  async function applyConsent() {
    const sections = getSections();
    if (!sections.length) return;
    // Services einmal holen und pro Section lokal matchen (kein Fetch je Section).
    const services = await getServices();
    for (const section of sections) {
      const service = findService(services, getServiceName(section));
      if (hasConsent(service)) {
        reveal(section);
      } else {
        hide(section);
      }
    }
  }

  function init() {
    applyConsent();
    // Auf spätere Consent-Änderungen (Banner oder Einstellungen) reagieren.
    window.addEventListener('UC_CONSENT', applyConsent);
    // Theme-Editor: neu geladene/eingefügte Sections erneut prüfen. Das per-Section
    // eingebundene Script wird durch den globalen Guard geblockt, daher übernimmt die
    // bereits laufende Instanz das Re-Init (getSections erfasst alle Instanzen).
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector('[data-inline-sales-agent]')) {
        applyConsent();
      }
    });
  }

  if (typeof UC_UI !== 'undefined' && UC_UI.isInitialized && UC_UI.isInitialized()) {
    init();
  } else {
    window.addEventListener('UC_UI_INITIALIZED', init);
  }
})();
